import { Link } from 'react-router';

export default function LegalLinks() {
  return (
    <nav aria-label="Legal information" className="mt-2 flex flex-wrap items-center justify-center gap-x-4">
      {([['/terms', 'Terms of Service'], ['/privacy', 'Privacy Policy']] as const).map(([path, label]) => (
        <Link
          key={path}
          to={path}
          className="min-h-11 inline-flex items-center text-sm underline underline-offset-4 active:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
          style={{ color: 'var(--app-text-muted)' }}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
